var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var WidgetPreview = function (_a) {
    var _b;
    var name = _a.name, size = _a.size, direction = _a.direction, disabled = _a.disabled;
    var widthMap = {
        1: 150,
        2: 200,
        3: 250,
        4: 300,
    };
    var previewWidth = (_b = widthMap[size]) !== null && _b !== void 0 ? _b : 120;
    return (_jsx("div", __assign({ className: "flex justify-center ".concat(disabled ? "opacity-50 pointer-events-none" : "") }, { children: _jsx("img", { src: "/images/widgets/".concat(name, "/").concat(name, "-").concat(size, "-").concat(direction, ".png"), alt: "Widget preview", style: { height: previewWidth }, className: "h-auto object-contain select-none", draggable: false }) })));
};
export default WidgetPreview;
